import { OperandOption, IProblem, IProblemGenerator } from "./sharedTypes";

const DEFAULT_MAX_OPERAND = 20;
const DEFAULT_MIN_OPERAND = 0;

export type SubtractionOptions = {
    operand1?: OperandOption;
    operand2?: OperandOption;
    progression?: boolean;
    progressionRate?: number;
}
export default class SubtractionProblemGenerator implements IProblemGenerator {
    private options?: SubtractionOptions;
    private currentStreak: number;

    constructor(options?: SubtractionOptions) {
        this.options = options;
        this.currentStreak = 0;
    }

    getNext() : IProblem {
        const op1Range = (this.options?.operand1?.max ?? 100) - (this.options?.operand1?.min ?? 0) + 1;
        const operand1 = Math.round(Math.random() * op1Range) + (this.options?.operand1?.min ?? 0);

        const op2Max = Math.min((this.options?.operand2?.max ?? 100), operand1) // can't subtract more than operand1
        const op2Min = (this.options?.operand2?.min ?? 0);
        const operand2 = Math.max(0, Math.round(Math.random() * (op2Max - op2Min + 1)) + op2Min - 1)

        return {
            generator: 'Subtraction',
            display: `${operand1} - ${operand2}`,
            correctAnswer: operand1 - operand2,
            userAnswer: undefined,
        }
    }
    reportResult(wasCorrect: boolean, userAnswer: number) {
        if (this.options?.progression === true) {

            if (wasCorrect) {
                this.currentStreak += 1;
                //console.log(`Current Streak: ${this.currentStreak}`);
            }

            if (this.currentStreak >= (this.options?.progressionRate ?? 10)) {
                console.log('Increasing subtraction difficulty', this.options);
                if (this.options?.operand1?.max)
                {
                    this.options.operand1.max += 1;
                    this.options.operand2 = { max: this.options.operand1.max }  
                }

                if (this.options?.operand1?.min) {
                    this.options.operand1.min += 1;
                }

                this.currentStreak = 0;
            }
        }
    }
}